class AboutPage {
  constructor() {
    this.setupOfficeGradients();

    this.modal = document.querySelector('.js-reagent-modal');
    if (!this.modal) {
      return;
    }
    this.openers = document.querySelectorAll('.js-reagent-modal-open');
    this.closers = this.modal.querySelectorAll('.js-reagent-modal-close');
    this.scrollTop = 0;
    this.bind();
  }

  setupOfficeGradients() {
    const sections = [
      {
        area: document.querySelector('.js-world-area'),
        list: document.querySelector('.js-world-list'),
      },
    ];

    const mm = gsap.matchMedia();

    sections.forEach(({ area, list }) => {
      if (!area || !list) return;

      const gradient = area.querySelector('.js-sticky-gradient');
      if (!gradient) return;

      gsap.set(gradient, { autoAlpha: 0 });

      const showGradient = () => {
        gsap.to(gradient, {
          autoAlpha: 1,
          duration: 0.6,
          ease: 'power3.out',
          overwrite: true,
        });
      };

      const hideGradient = () => {
        gsap.to(gradient, {
          autoAlpha: 0,
          duration: 0.6,
          ease: 'power3.out',
          overwrite: true,
        });
      };

      // PC: リスト上端が画面中央に来たとき
      mm.add('(min-width: 768px)', () => {
        ScrollTrigger.create({
          trigger: list,
          start: 'top center',
          end: 'bottom top',
          onEnter: showGradient,
          onLeave: hideGradient,
          onEnterBack: showGradient,
          onLeaveBack: hideGradient,
        });
      });
    });
  }

  bind() {
    this.openers.forEach((opener) => {
      opener.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });
    });

    this.closers.forEach((closer) => {
      closer.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open() {
    this.scrollTop = window.scrollY || 0;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-reagent-modal-open');
    document.documentElement.style.top = `${-this.scrollTop}px`;
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-reagent-modal-open');
    document.documentElement.style.top = '';
    window.scrollTo(0, this.scrollTop);
  }
}
